import React from "react"
import PropTypes from "prop-types"
import {
  reservationTitle,
  reservationSubContainer,
} from "../Part1/reservation-part-1.module.scss"
import {
  ReservationSubContainer,
  ReservationTitle,
} from "../reservation-styled.js"

export const ReservationPart2 = ({ typesReservationData, typeChoisi }) => {
  return (
    <ReservationSubContainer className={reservationSubContainer}>
      <ReservationTitle className={reservationTitle}>
        Information pour votre réservation
      </ReservationTitle>
      {typesReservationData[typeChoisi] && (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html:
                typesReservationData[typeChoisi].texte_commentaire[0].processed,
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: typesReservationData[typeChoisi].texte_rgpd[0].processed,
            }}
          />
        </>
      )}
    </ReservationSubContainer>
  )
}

ReservationPart2.propTypes = {
  typesReservationData: PropTypes.object,
  typeChoisi: PropTypes.string,
}
